import React from "react";
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { QuestionCaseInfo, Tin } from '../../../api/types/questions';
import { themeColor } from '../../../components/Theme';
import { Title } from '../Questions.style';
import { QuestionCaseEntityLine } from './QuestionCaseEntityLine';
import { useLocale } from "../../../toolympus/components/localization";

export interface QuestionCasePlaintiffsProps {
    type: "claimants" | "respondants" | "other_sides",
    case_info: QuestionCaseInfo
}

export const QuestionCasePlaintiffs = ({ case_info, type }: QuestionCasePlaintiffsProps) => {
    const { locale } = useLocale();

    const participants = (case_info[type] || []) as Tin[];
    return (
      <Wrapper>
        <ContentTitle className="section-title" margin = {"20px auto 15px 0"} color = {themeColor(c => c.blackDefault)} font = {"500 20"}>
          <FormattedMessage id={`question.${type}`} />
        </ContentTitle>

        {!participants.length && 
          <FormattedMessage id="addition.empty" />}

        {participants.map((item, id) => (
          <QuestionCaseEntityLine
            key={id}
            title={locale === "en" ? (item.title_en || item.title) : item.title}
            inn={item.inn}
            />))}

      </Wrapper>)
}

const Wrapper = styled.div`
    width: 100%;
`;

const ContentTitle = styled(Title)`
    text-align: center;
`;
